<template>
  <v-container fluid class="pl-md-5 pb-16">
    <v-skeleton-loader v-if="loading" type="article"></v-skeleton-loader>
    <div v-if="list && !loading">
      <v-form
        ref="form"
        v-model="valid"
        @submit.prevent="submit"
        lazy-validation
        class="mt-4 pb-10"
      >
        <v-alert dense outlined type="error" v-if="error">
          <ul>
            <li v-for="item in error" :key="item.msg">{{ $t(item.msg) }}</li>
          </ul>
        </v-alert>
        <div class="text-h5 mb-5">{{ $t("EditPrice") }}</div>
        <v-card class="mb-5" outlined>
          <v-card-text class="pt-5">
            <v-row>
              <v-col cols="7">
                <div class="text-h6 pb-2">
                  {{ $t("Baseprice") }}
                </div>
                <v-row>
                  <v-col cols="7">
                    <v-text-field
                      type="text"
                      v-model="list.price"
                      :suffix="list.currency_code"
                      :rules="numberRule"
                      v-bind:label="$t('Dailyprice')"
                      placeholder="Ex:120"
                      outlined
                    ></v-text-field>
                  </v-col>
                  <v-col cols="5">
                    <v-select
                      outlined
                      :items="currencies"
                      item-value="code"
                      item-text="code"
                      v-model="list.currency_code"
                      :label="$t('Currency')"
                    ></v-select>
                  </v-col>
                </v-row>
                <div class="text-h6 pb-2">
                  {{ $t("PM1") }}
                </div>
                <p>{{ $t("PM2") }}</p>
                <v-row>
                  <v-col cols="7">
                    <v-text-field
                      type="text"
                      v-model="list.weekly_price"
                      :rules="numberRule"
                      v-bind:label="$t('Weeklyprice')"
                      placeholder="Ex:820"
                      v-bind:hint="$t('PM3')"
                      :suffix="list.currency_code"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="7">
                    <v-alert dense type="info">
                      <a
                        class="white--text"
                        href="https://member.nomadrooms.com/checkout/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {{ $t("s1656699105") }}</a
                      >
                    </v-alert>
                    <v-text-field
                      type="text"
                      v-model="list.monthly_price"
                      :rules="numberRule"
                      v-bind:label="$t('Monthlyprice')"
                      placeholder="Ex:3300"
                      v-bind:hint="$t('PM4')"
                      :suffix="list.currency_code"
                      persistent-hint
                      outlined
                    ></v-text-field>
                    <div v-if="list.monthly_price">
                      <div class="overline pb-0 grey--text">
                        {{ $t("SecurityDeposittobeCollected") }}
                      </div>
                      <div class="text-h6">
                        {{ list.currency_code }}
                        {{ list.monthly_price }} ({{ $t("Morethan6months") }})
                      </div>
                      <div class="text-h6">
                        {{ list.currency_code }}
                        {{ list.monthly_price / 2 }} ({{
                          $t("Lessthan6months")
                        }})
                      </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <div class="text-h6 pb-2">
                  {{ $t("PM5") }}
                </div>
                <v-row>
                  <v-col cols="12">
                    <v-select
                      :label="$t('PM6')"
                      v-bind:hint="$t('PM8')"
                      v-model="list.short_term_buffer"
                      :items="short_bf"
                      item-text="text"
                      item-value="abbr"
                      :rules="reqRules"
                      persistent-hint
                      outlined
                    ></v-select>
                  </v-col>
                  <v-col cols="12">
                    <v-select
                      :label="$t('PM7')"
                      v-bind:hint="$t('PM8')"
                      v-model="list.long_term_buffer"
                      :items="long_bf"
                      item-text="text"
                      item-value="abbr"
                      :rules="reqRules"
                      persistent-hint
                      outlined
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-footer fixed>
          <v-col class="text-center" cols="12">
            <v-btn type="submit" dark min-width="150" color="light-blue">
              <span class="mr-2">{{ $t("Save") }}</span>
            </v-btn>
            <v-btn
              color="light-blue"
              text
              class="ml-2"
              min-width="150"
              :to="{
                name: 'PartnerListingViewComponent',
                params: { id: parm }
              }"
            >
              <span>{{ $t("Back") }}</span>
            </v-btn>
          </v-col>
        </v-footer>
        <WaitDialogComponent :waitDialog="waitDialog" />
      </v-form>
    </div>
  </v-container>
</template>

<script>
// @ is an alias to /src
import timeoutMixin from "@/mixins/timeoutMixin.js";
import WaitDialogComponent from "@/components/layout/WaitDialogComponent.vue";
import Currencies from "@/assets/currencies.json";
import ListingsData from "@/assets/listings.json";
import ListingService from "@/services/ListingService";

export default {
  name: "EditPriceComponent",
  components: { WaitDialogComponent },
  mixins: [timeoutMixin],
  data() {
    return {
      list: null,
      loading: true,
      parm: this.$route.params.id,
      currencies: Currencies,
      short_bf: ListingsData.short_bf,
      long_bf: ListingsData.long_bf,
      waitDialog: false,
      valid: null,
      error: null,
      reqRules: [value => !!value || this.$t("string719")],
      numberRule: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /^\d+(?:\d+)*$/gm;
          return pattern.test(value) || this.$t("string721");
        }
      ]
    };
  },
  created: function() {
    ListingService.viewProperty({
      id: this.parm
    })
      .then(result => {
        this.list = result.data.item;
        this.loading = false;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    async submit() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.waitDialog = true;
        await ListingService.propertyUpdate(this.list)
          .then(() => {
            setTimeout(
              () => (
                (this.waitDialog = false),
                this.$router.push({
                  name: "PartnerListingViewComponent",
                  params: { id: this.parm }
                })
              ),
              500
            );
          })
          .catch(err => {
            this.error = err.response.data.errors;
            setTimeout(() => (this.waitDialog = false), 500);
          });
      }
    }
  }
};
</script>

<style></style>
